import { RightArrowIcon } from '@/components/icons/RightArrowIcon'
import {
  ENABLE_POOL_PER_MINER_UI,
  SUPPORT_MINING_POOL_REQUEST_URL,
} from '@/constants'
import {
  Text,
  Link,
  Center,
  Box,
  Heading,
  Stack,
  useColorModeValue,
  Button,
  useDisclosure,
  Divider,
  HStack,
  Flex,
} from '@chakra-ui/react'
import { useTranslations } from 'next-intl'

interface IProps {
  onOpen: () => void
}

const SetPoolAccount = ({ onOpen }: IProps) => {
  const t = useTranslations()
  const gray880 = useColorModeValue('gray.880', 'gray.200')
  const blackOrWhite = useColorModeValue('black', 'white')
  const whiteOrBlack = useColorModeValue('white', 'whiteAlpha.200')
  return (
    <Stack align="start" mb="8">
      <HStack w="full">
        <Flex
          direction={{ base: 'column', md: 'row' }}
          gap="2"
          w="full"
          justifyContent={{ base: 'flex-start', md: 'space-between' }}
          alignItems={{ base: 'flex-start', md: 'center' }}
        >
          <Heading
            fontSize={{ base: '3xl' }}
            fontWeight="500"
            w="full"
            textAlign="left"
            color={gray880}
          >
            {t('dashboard.mining-pool.pool-management')}
          </Heading>

          <Button
            onClick={onOpen}
            bg={whiteOrBlack}
            border="1px solid var(--blackAlpha-200, rgba(0, 0, 0, 0.08))"
            color={blackOrWhite}
            rounded={'md'}
            justifySelf={'flex-start'}
            textAlign={'left'}
            w={{ base: 'auto', md: '50%', xl: '30%', xxl: '20%' }}
          >
            {t('dashboard.mining-pool.add-pool-account')}
          </Button>
        </Flex>
      </HStack>
      <Divider w="full" mt="3" color="gray.400" size={'1px'} />
      {ENABLE_POOL_PER_MINER_UI === 'true' && (
        <Button
          colorScheme="brand"
          onClick={onOpen}
          bg={blackOrWhite}
          color={whiteOrBlack}
        >
          {t('dashboard.mining-pool.add-pool-account')}
        </Button>
      )}
    </Stack>
  )
}

export default SetPoolAccount
